import { z } from 'zod';

export const RevisionPlanCandidateSchema = z.object({
  itemType: z.enum(['PRODUCT', 'SERVICE']),
  itemId: z.uuid(),
  name: z.string(),
  code: z.string().nullable(),
  sku: z.string().nullable(),
});

export const RevisionPlanSlotSelectionSchema = z.enum(['SINGLE', 'MULTIPLE', 'EMPTY']);

export const RevisionPlanResolvedSlotSchema = z.object({
  genericProductId: z.uuid(),
  canonicalName: z.string(),
  position: z.number().int().nonnegative(),
  candidates: z.array(RevisionPlanCandidateSchema),
  selection: RevisionPlanSlotSelectionSchema,
  preselectedItemId: z.uuid().optional(),
});

export const RevisionPlanCompositionItemSchema = z.object({
  genericProductId: z.uuid(),
  canonicalName: z.string(),
});

export const RevisionPlanResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  items: z.array(RevisionPlanCompositionItemSchema),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type RevisionPlanCandidate = z.infer<typeof RevisionPlanCandidateSchema>;
export type RevisionPlanSlotSelection = z.infer<typeof RevisionPlanSlotSelectionSchema>;
export type RevisionPlanResolvedSlot = z.infer<typeof RevisionPlanResolvedSlotSchema>;
export type RevisionPlanCompositionItem = z.infer<typeof RevisionPlanCompositionItemSchema>;
export type RevisionPlanResponse = z.infer<typeof RevisionPlanResponseSchema>;
